<template>
  <ul>
    <template v-for="item in filteredSidebar" :key="item.tittle">
      <li class="submenu-open">
        <h6 class="submenu-hdr">{{ item.tittle }}</h6>
        <ul>
          <template v-for="menu in item.menu" :key="menu.menuValue">
            <router-link v-if="menu.route" :to="menu.route" custom v-slot="{ href, navigate }">
              <li :class="{ active: isActive(menu.route) }">
                <a :href="href" @click="navigate">
                  <vue-feather :type="menu.icon"></vue-feather>
                  <span>{{ menu.menuValue }} </span>
                </a>
              </li>
            </router-link>
            <li v-else :class="{ submenu: true, subdrop: menu.showSubRoute }">
              <a
                href="javascript:void(0)"
                :class="{
                  subdrop: menu.showSubRoute,
                  active: isActive(menu.route) || route_array[1] === menu.active_link,
                }"
                @click="expandSubMenus(menu)"
              >
                <vue-feather :type="menu.icon"></vue-feather>
                <span>{{ menu.menuValue }}</span>
                <span class="menu-arrow"></span>
              </a>
              <ul :class="{ 'd-block': menu.showSubRoute, 'd-none': !menu.showSubRoute }">
                <template v-for="subMenu in menu.subMenus" :key="subMenu.id">
                  <router-link :to="subMenu.route" custom v-slot="{ href, navigate }">
                    <li :class="{ active: isActive(subMenu.route) }">
                      <a :href="href" @click="navigate" class="sub-active">
                        {{ subMenu.menuValue }}
                      </a>
                    </li>
                  </router-link>
                </template>
              </ul>
            </li>
            <li v-if="menu.hasSubRouteTwo" class="submenu">
              <a
                href="javascript:void(0);"
                @click="openMenu(menu)"
                :class="{
                  subdrop: openMenuItem === menu,
                  active: isActive(menu.route) || route_array[1] === menu.active_link,
                }"
              >
                <vue-feather :type="menu.icon"></vue-feather
                ><span>{{ menu.menuValue }}</span>
                <span class="menu-arrow"></span>
              </a>
              <ul
                :class="{
                  'd-block': openMenuItem === menu,
                  'd-none': openMenuItem !== menu,
                }"
              >
                <li v-for="subMenus in menu.subMenus" :key="subMenus.menuValue">
                  <template v-if="!subMenus.customSubmenuTwo">
                    <router-link :to="subMenus.route" custom v-slot="{ href, navigate }">
                      <li :class="{ active: isActive(subMenus.route) }">
                        <a :href="href" @click="navigate">{{ subMenus.menuValue }}</a>
                      </li>
                    </router-link>
                  </template>
                  <template v-else-if="subMenus.customSubmenuTwo">
                    <li class="submenu submenu-two">
                      <a
                        href="javascript:void(0);"
                        @click="openSubmenuOne(subMenus)"
                        :class="{ subdrop: openSubmenuOneItem === subMenus }"
                      >
                        {{ subMenus.menuValue }}
                        <span class="menu-arrow inside-submenu"></span>
                      </a>
                      <ul
                        :class="{
                          'd-block': openSubmenuOneItem === subMenus,
                          'd-none': openSubmenuOneItem !== subMenus,
                        }"
                      >
                        <li
                          v-for="subMenuTwo in subMenus.subMenusTwo"
                          :key="subMenuTwo.menuValue"
                        >
                          <router-link :to="subMenuTwo.route" custom v-slot="{ href, navigate }">
                            <li :class="{ active: isActive(subMenuTwo.route) }">
                              <a :href="href" @click="navigate">{{ subMenuTwo.menuValue }}</a>
                            </li>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </template>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </li>
    </template>
  </ul>
</template>

<script>
import sideBarData from "@/assets/json/sidebar.json";

export default {
  data() {
    return {
      sideBarData: sideBarData,
      route_array: [],
      openMenuItem: null,
      openSubmenuOneItem: null,
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    filteredSidebar() {
      const perms = (mod, act) => this.$hasPermission('ssp', mod, act);
      
      return this.sideBarData.map(item => {
        const filteredMenu = item.menu.filter(m => {
          // Master Data module checks
          if (m.menuValue === "Daftar Produk") return perms('products', 'view');
          if (m.menuValue === "Sumber Produk") return perms('sources', 'view');
          if (m.menuValue === "Kios SSP") return perms('members', 'view');
          if (m.menuValue === "Petugas Pendamping") return perms('pendampings', 'view');
          
          // Purchase Order module checks (all sub-menus in this category check 'orders' permission)
          if (item.tittle === "Purchase Order") return perms('orders', 'view');
          
          // Default: If it's something else not caught above, check if it's in Master Data
          if (item.tittle === "Master Data") return false; // Any other uncaught master data should hide
          
          return true; // Default show for other sections if any
        });
        
        return { ...item, menu: filteredMenu };
      }).filter(item => item.menu && item.menu.length > 0);
    }
  },
  watch: {
    $route() {
      this.updateRouteArray();
    },
  },
  mounted() {
    this.updateRouteArray();
  },
  methods: {
    isActive(targetRoute) {
      if (!targetRoute) return false;
      
      const current = this.$route;
      
      // Separate path and query from target
      let [targetPath, targetQueryStr] = targetRoute.split('?');
      targetPath = targetPath.replace(/\/$/, ""); 
      
      const currentPath = current.path.replace(/\/$/, "");
      
      // 1. Path must match
      if (currentPath !== targetPath) {
        return false;
      }
      
      // 2. Query matching
      if (targetQueryStr) {
        const targetParams = new URLSearchParams(targetQueryStr);
        // Check if all params in target exist and match in current query
        return Array.from(targetParams.entries()).every(([key, value]) => 
          String(current.query[key]) === String(value)
        );
      } else {
        // If target has no query, current should have no status to be the "active" root
        // This is specific to pages that use status as a primary sub-filter in sidebar
        return !current.query.status;
      }
    },
    expandSubMenus(menu) {
      this.sideBarData.forEach((item) => {
        item.menu.forEach((subMenu) => {
          if (subMenu !== menu) {
            subMenu.showSubRoute = false;
          }
        });
      });
      menu.showSubRoute = !menu.showSubRoute;
    },
    updateRouteArray() {
      this.route_array = this.$route.path.split("/");
    },
    openMenu(menu) {
      this.openMenuItem = this.openMenuItem === menu ? null : menu;
    },
    openSubmenuOne(subMenus) {
      this.openSubmenuOneItem = this.openSubmenuOneItem === subMenus ? null : subMenus;
    },
  },
};
</script>
